import ReferenceListItemView from './ReferenceListItemView';
import template from '../templates/userReferenceListItem.hbs';
import { Handlebars } from 'lib';

export default ReferenceListItemView.extend({
    template: Handlebars.compile(template)
});



// WEBPACK FOOTER //
// ../src/form/editors/impl/reference/views/UserReferenceListItemView.js